import { createType } from 'framework/utils/createType';

export const LumpSumTypes = createType('FailedTrial', 'PassedAway');
export type LumpSumType = typeof LumpSumTypes[number];
